module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "extraFilter"
    }
  }, [_c('h4', [_vm._v("Filter By")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.toggleYearOff),
      expression: "toggleYearOff"
    }],
    staticClass: "filterSelector yearSelector",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "selectorValue",
    on: {
      "click": _vm.toggleYear
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$parent.year || 'Year') + "\n      "), _c('img', {
    class: _vm.yearToggled ? 'toggled' : '',
    attrs: {
      "src": require("../../assets/images/FilterCaret.svg"),
      "width": "18",
      "height": "10"
    }
  })]), _vm._v(" "), (_vm.yearToggled) ? _c('div', {
    staticClass: "selectorOptions"
  }, [_c('p', {
    attrs: {
      "data-value": ""
    },
    on: {
      "click": function($event) {
        _vm.selectYear($event)
      }
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "mdi:close"
    }
  }), _vm._v(" Clear Filter\n      ")], 1), _vm._v(" "), _c('ul', _vm._l((_vm.years), function(yr) {
    return _c('li', {
      attrs: {
        "data-value": yr
      },
      on: {
        "click": function($event) {
          _vm.selectYear($event)
        }
      }
    }, [_vm._v(_vm._s(yr))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.toggleTopicOff),
      expression: "toggleTopicOff"
    }],
    staticClass: "filterSelector topicSelector",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "selectorValue",
    on: {
      "click": _vm.toggleTopic
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$parent.thisTopic ? _vm.$parent.thisTopic.name : 'Topic') + "\n      "), _c('img', {
    class: _vm.topicToggled ? 'toggled' : '',
    attrs: {
      "src": require("../../assets/images/FilterCaret.svg"),
      "width": "18",
      "height": "10"
    }
  })]), _vm._v(" "), (_vm.topicToggled) ? _c('div', {
    staticClass: "selectorOptions"
  }, [_c('p', {
    attrs: {
      "data-value": ""
    },
    on: {
      "click": function($event) {
        _vm.selectTopic($event)
      }
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "mdi:close"
    }
  }), _vm._v(" Clear Filter\n      ")], 1), _vm._v(" "), _c('ul', _vm._l((_vm.topics), function(topic) {
    return _c('li', {
      attrs: {
        "data-value": topic.slug
      },
      on: {
        "click": function($event) {
          _vm.selectTopic($event)
        }
      }
    }, [_vm._v(_vm._s(topic.name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-041b1fd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/extras/ExtraFilter.vue
// module id = 755
// module chunks = 1